export enum ADMIN_MODAL_TYPE {
  APPOINTMENT_DETAILS = 'APPOINTMENT_DETAILS',
  CREATE_APPOINTMENT = 'CREATE_APPOINTMENT',
  CALENDAR_DETAILS = 'CALENDAR_DETAILS',
  REMOVE_APPOINTMENT = 'REMOVE_APPOINTMENT',
  CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT',
  ADD_STAFF = 'ADD_STAFF',
  ADD_HMO_MODAL = 'ADD_HMO_MODAL',
  ADD_HMO_PLAN = 'ADD_HMO_PLAN',
  REMOVE_PLAN = 'REMOVE_PLAN',
  ADD_TARIFF = 'ADD_TARIFF',
  REMOVE_TARIFF = 'REMOVE_TARIFF',
  EDIT_TARIFF = 'EDIT_TARIFF',
  ADD_HMO_TARIFF = 'ADD_HMO_TARIFF',
  EDIT_HMO_TARIFF = 'EDIT_HMO_TARIFF',
  REMOVE_HMO_TARIFF = 'REMOVE_HMO_TARIFF',
  REMOVE_PROCEDURE_MODAL = 'REMOVE_PROCEDURE_MODAL',
  REMOVE_DRUG_MODAL = 'REMOVE_DRUG_MODAL',
  REMOVE_HMO_MODAL = 'REMOVE_HMO_MODAL',
  ADD_LABORATORY_MODAL = 'ADD_LABORATORY_MODAL',
  EDIT_LABORATORY_MODAL = 'EDIT_LABORATORY_MODAL',
  EDIT_LAB_PRICE_MODAL = 'EDIT_LAB_PRICE_MODAL',
  REMOVE_LABORATORY_MODAL = 'REMOVE_LABORATORY_MODAL',
  ADD_IMAGING_MODAL = 'ADD_IMAGING_MODAL',
  REMOVE_IMAGING_MODAL = 'REMOVE_IMAGING_MODAL',
  EDIT_IMAGING_PRICE_MODAL = 'EDIT_IMAGING_PRICE_MODAL',
  EDIT_IMAGING_MODAL = 'EDIT_IMAGING_MODAL',
  ADD_CONSENT_FORM = 'ADD_CONSENT_FORM',
  DELETE_CONSENT_FORM = 'DELETE_CONSENT_FORM',
  ADD_UNIT_MODAL = 'ADD_UNIT_MODAL',
  EDIT_UNIT_MODAL = 'EDIT_UNIT_MODAL',
  DELETE_UNIT_MODAL = 'DELETE_UNIT_MODAL',
  ADD_BED_MODAL = 'ADD_BED_MODAL',
  EDIT_BED_MODAL = 'EDIT_BED_MODAL',
  REMOVE_BED_MODAL = 'REMOVE_BED_MODAL',
  BED_DETAIL_MODAL = 'BED_DETAIL_MODAL',
  REQUEST_DETAIL_MODAL = 'REQUEST_DETAIL_MODAL',
  ASSIGN_BED_MODAL = 'ASSIGN_BED_MODAL',
  ADD_ROOM_MODAL = 'ADD_ROOM_MODAL',
  EDIT_ROOM_MODAL = 'EDIT_ROOM_MODAL',
  REMOVE_ROOM_MODAL = 'REMOVE_ROOM_MODAL',
  SYNTAX_CODE = 'SYNTAX_CODE',
  ADD_ITEM = 'ADD_ITEM',
  EDIT_ITEM = 'EDIT_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
  ASSIGN_PATIENT = 'ASSIGN_PATIENT',
  VIEW_PATIENT = 'VIEW_PATIENT',
  ADD_PATIENT = 'ADD_PATIENT',
  REMOVE_PATIENT = 'REMOVE_PATIENT',
  EDIT_PATIENT = 'EDIT_PATIENT',
  SUCCESS_MODAL = 'SUCCESS_MODAL',
  UPLOAD_MODAL = 'UPLOAD_MODAL',
  CONSENT_FORM = 'CONSENT_FORM',
  PROCEDURE_APPROVAL = 'PROCEDURE_APPROVAL',
  INTAKE_APROVAL = 'INTAKE_APROVAL',
  ADD_TEMPLATE = 'ADD_TEMPLATE',
  ADD_VITAL = 'ADD_VITAL',
  ADD_CHARGE_ITEM = 'ADD_CHARGE_ITEM',
  DRUG_MODAL = 'DRUG_MODAL',
  ADMIN_HELP_GUIDE = 'ADMIN_HELP_GUIDE',
  BULK_FILE_UPLOAD = 'BULK_FILE_UPLOAD',
  HMO_BULK_MAP_MODAL = 'HMO_BULK_MAP_MODAL',
  PATIENT_BULK_MAP_MODAL = 'PATIENT_BULK_MAP_MODAL',
  STAFF_BULK_MAP_MODAL = 'STAFF_BULK_MAP_MODAL',
  IMAGING_BULK_MAP_MODAL = 'IMAGING_BULK_MAP_MODAL',
  PROCEDURE_BULK_MAP_MODAL = 'PROCEDURE_BULK_MAP_MODAL',
  LAB_TEST_BULK_MAP_MODAL = 'LAB_TEST_BULK_MAP_MODAL',
  FACILITY_MODAL = 'FACILITY_MODAL',
  REMOVE_FACILITY_MODAL = 'REMOVE_FACILITY_MODAL',
  ADD_ARCHIVE_RECORD = 'ADD_ARCHIVE_RECORD',
  ARCHIVE_FILE_DETAILS = 'ARCHIVE_FILE_DETAILS',
  UPLOAD_ARCHIVE_DOCUMENT = 'UPLOAD_ARCHIVE_DOCUMENT',
  ARCHIVE_DOCUMENT_DETAILS = 'ARCHIVE_DOCUMENT_DETAILS'
}
